import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { selectPutProjectState } from '../selectors';
import { HomeProject } from '@models/swagger';

export const getData = createSelector(selectPutProjectState, (state: State) => state.data);

export const getError = createSelector(selectPutProjectState, (state: State) => state.error);

export const getLoading = createSelector(selectPutProjectState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomeProject) => T) =>
  createSelector(selectPutProjectState, (state: State) => fn(state.data));
